import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { type IntroEffectMessage, isIntroEffectMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import {
  type EventAnimCoinMessage,
  type EventRankMessage,
  isEventAnimCoinMessage,
  isEventRankMessage,
} from '@module/types/centrifuge/public-message/eventMessageTypes';
import {
  type HeartIconVIPMessage,
  isHeartIconVipMessage,
} from '@module/types/centrifuge/public-message/heartIconVIPMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class IntroEffectHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<IntroEffectMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isIntroEffectMessage(payload);
  }

  handle(payload: IntroEffectMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작 (USE_DEFAULT)
    context.triggers?.introEffect?.(payload.data.message);
  }
}

export class EventAnimCoinHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<EventAnimCoinMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isEventAnimCoinMessage(payload);
  }

  handle(payload: EventAnimCoinMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작 (USE_DEFAULT)
    context.triggers?.eventAnimCoin?.(payload);
  }
}

export class EventRankHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<EventRankMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isEventRankMessage(payload);
  }

  handle(payload: EventRankMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작 (USE_DEFAULT)
    context.updateEventRank(payload.data.message);
  }
}

export class HeartIconVipHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<HeartIconVIPMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isHeartIconVipMessage(payload);
  }

  handle(payload: HeartIconVIPMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작 (USE_DEFAULT)
    context.enqueueVIPSponEffect?.(payload);
  }
}
